module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-fluid clearfix merchant-page",
    attrs: {
      "id": "merchant"
    }
  }, [_c('div', {
    staticClass: "merch-sidebar"
  }, [_c('div', {
    staticClass: "nc-s-c-s1 ncs-search-bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content merch-serach"
  }, [_c('p', [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择省份",
      "transfer": true
    },
    on: {
      "on-change": _vm.fetchCityList
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v("\n              " + _vm._s(item.localName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择市",
      "transfer": true
    },
    on: {
      "on-change": _vm.fetchRegionList
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v("\n              " + _vm._s(item.localName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择区",
      "transfer": true
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  }, _vm._l((_vm.regionList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v("\n              " + _vm._s(item.localName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择店铺类型"
    },
    model: {
      value: (_vm.storeType),
      callback: function($$v) {
        _vm.storeType = $$v
      },
      expression: "storeType"
    }
  }, _vm._l((_vm.storeTypeList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('p', [_c('Input', {
    staticClass: "asdf22",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入商家名"
    },
    model: {
      value: (_vm.storeName),
      callback: function($$v) {
        _vm.storeName = $$v
      },
      expression: "storeName"
    }
  })], 1), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "ghost",
      "size": "small",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchStore
    }
  }, [_vm._v("搜索商家")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "merch-content"
  }, [_c('store-list', {
    attrs: {
      "data": _vm.storesList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tc mt20 mb20"
  }, [(_vm.storesList.length == 0 && !this.loading) ? _c('Alert', [_vm._v("\n        没有更多数据...\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount>0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("本地商户搜索")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e949b7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/same-city-businesses/index.vue
// module id = 1581
// module chunks = 1